/** Statuses 6–9 are the four steps of a run; 3 (Busy) and 10 (Queued) wait for one. */
export const STEP_COUNT = 4;

const RUNNING = new Set([6, 7, 8, 9]);
const QUEUED = new Set([3, 10]);

export function isRunningStatus(status: number | null | undefined): boolean {
  return RUNNING.has(Number(status));
}

export function isQueuedStatus(status: number | null | undefined): boolean {
  return QUEUED.has(Number(status));
}

/** The step a running status is on, 0–3. */
export function stepOf(status: number): number {
  return Math.min(STEP_COUNT - 1, Math.max(0, status - 6));
}

/** The stage of a running status in plain words. */
export function stageWord(status: number, runType?: number | null, projectType?: string | null): string {
  if (projectType === 'soft_jaws' || projectType === 'mold') return 'Generating';
  switch (status) {
    case 6:
      return 'Preparing';
    case 7:
      return runType === 1 ? 'Running' : 'Optimizing';
    case 8:
      return 'Post-processing';
    default:
      return 'Finishing';
  }
}
